<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="coord?.tel" 
[label]="step5.gettel"
[type]="'text'"
[rule]="'pattern_8|minSize_10|maxSize_15'"
[errorMessage]="{'pattern' : 'ctr_208', 'minLength' : 'ctr_208_longueur'}"
[name]="getUid()+'_SepAtt_tel'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="coord?.fax" 
[label]="step5.getfax"
[type]="'text'"
[rule]="'pattern_8|minSize_10|maxSize_15'"
[errorMessage]="{'pattern' : 'ctr_209', 'minLength' : 'ctr_209'}"
[name]="getUid()+'_SepAtt_fax'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="coord?.mel" 
[label]="step5.getmel"
[type]="'text'"
[rule]="'pattern_1|maxSize_200'"
[errorMessage]="{'pattern' : 'ctr_117'}"
[name]="getUid()+'_SepAtt_mel'">
</app-form-input>

<!-- URL pouvoir adjudicateur -->
<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="coord?.url" 
[label]="step5.geturl"
[type]="'text'"
[rule]="'maxSize_200|pattern_33'"
[errorMessage]="{'pattern' : 'ctr_7'}"
[name]="getUid()+'_SepAtt_url'">
</app-form-input>
